import * as Types from '../actions/action.types';
export const defaultState = {
	resultMessage: null as string,
};
export type ReducerState = typeof defaultState;
export function reducer(state = defaultState, action: any): ReducerState {
	switch (action.type) {
		case Types.PWD_EXPIRED_RESET_PASSWORD:
			return {
				...state,
				resultMessage: action.payload,
			};
		default:
			return state;
	}
}
